var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignmentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3821_2911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.212891,
    width: 49,
    height: 49,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3821_2911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 43.0879C9.08542 43.0879 8.12413 42.688 7.32448 41.8884C6.52483 41.0887 6.125 40.1274 6.125 39.0045V10.4212C6.125 9.29827 6.52483 8.33698 7.32448 7.53733C8.12413 6.73768 9.08542 6.33785 10.2083 6.33785H18.7833C19.2257 5.11285 19.9658 4.12604 21.0036 3.37743C22.0415 2.62882 23.2069 2.25452 24.5 2.25452C25.7931 2.25452 26.9585 2.62882 27.9964 3.37743C29.0342 4.12604 29.7743 5.11285 30.2167 6.33785H38.7917C39.9146 6.33785 40.8759 6.73768 41.6755 7.53733C42.4752 8.33698 42.875 9.29827 42.875 10.4212V24.1004C42.2285 23.7941 41.5649 23.5304 40.8844 23.3092C40.2038 23.088 39.5062 22.9264 38.7917 22.8243V10.4212H10.2083V39.0045H22.5604C22.6625 39.7531 22.8241 40.4677 23.0453 41.1483C23.2665 41.8288 23.5302 42.4754 23.8365 43.0879H10.2083ZM10.2083 39.0045V10.4212V22.8243V22.6712V39.0045ZM14.2917 34.9212H22.6115C22.7135 34.2066 22.8752 33.509 23.0964 32.8285C23.3175 32.1479 23.5642 31.4844 23.8365 30.8379H14.2917V34.9212ZM14.2917 26.7545H26.7458C27.8347 25.7337 29.0512 24.883 30.3953 24.2024C31.7394 23.5219 33.1771 23.0625 34.7083 22.8243V22.6712H14.2917V26.7545ZM14.2917 18.5879H34.7083V14.5045H14.2917V18.5879ZM24.5 8.88993C24.9424 8.88993 25.3082 8.74532 25.5974 8.45608C25.8866 8.16684 26.0312 7.80104 26.0312 7.35868C26.0312 6.91632 25.8866 6.55052 25.5974 6.26129C25.3082 5.97205 24.9424 5.82743 24.5 5.82743C24.0576 5.82743 23.6918 5.97205 23.4026 6.26129C23.1134 6.55052 22.9687 6.91632 22.9687 7.35868C22.9687 7.80104 23.1134 8.16684 23.4026 8.45608C23.6918 8.74532 24.0576 8.88993 24.5 8.88993ZM36.75 47.1712C33.9257 47.1712 31.5182 46.1759 29.5276 44.1852C27.537 42.1946 26.5417 39.7872 26.5417 36.9629C26.5417 34.1385 27.537 31.7311 29.5276 29.7405C31.5182 27.7498 33.9257 26.7545 36.75 26.7545C39.5743 26.7545 41.9818 27.7498 43.9724 29.7405C45.963 31.7311 46.9583 34.1385 46.9583 36.9629C46.9583 39.7872 45.963 42.1946 43.9724 44.1852C41.9818 46.1759 39.5743 47.1712 36.75 47.1712ZM35.7292 43.0879H37.7708V37.9837H42.875V35.942H37.7708V30.8379H35.7292V35.942H30.625V37.9837H35.7292V43.0879Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentBlack);
export default __webpack_public_path__ + "static/media/assignmentBlack.ec5d2dcd7b97ed82066fe88242e775fb.svg";
export { ForwardRef as ReactComponent };